import { render, staticRenderFns } from "./ItemEtapa.vue?vue&type=template&id=055352c0&"
import script from "./ItemEtapa.vue?vue&type=script&lang=js&"
export * from "./ItemEtapa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports